import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enMessage from './en.json';
import jpnMessage from './jpn.json';

Vue.use(VueI18n);

const messages = {
    en: enMessage,
    jpn: jpnMessage,
};

const i18n = new VueI18n({
    locale: 'jpn', // set locale
    messages,
    fallbackLocale: 'jpn',
});

export default i18n;
